// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"

Rails.start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("jquery")

 

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

require("trix")
require("@rails/actiontext")


require.context('../application/images', true, /\.(gif|jpe?g|png|svg)$/)

import '../application/javascripts/bootstrap.min.js'
import '../application/javascripts/modal.js'
import '../application/javascripts/social-share-button.js'
import '../application/javascripts/jquery.Jcrop.js'
import '../application/javascripts/crop.js'
import '../application/javascripts/custom/play-song.js'
import '../application/javascripts/custom/custom.js'
